export default __webpack_public_path__ + "static/media/Back.f319897a.svg";